import script from "./EventIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventIcon.vue?vue&type=script&lang=ts&setup=true"

import "./EventIcon.vue?vue&type=style&index=0&id=1d313a93&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d313a93"]])

export default __exports__